<template>
  <div>
    <projectsDates
      :ProjectID="ProjectID"
      :projectNumber="projectNumber"
      :projectSummary="projectSummary"
      :userCanEditProjectItems="userCanEditProjectItems"
    ></projectsDates>
    <projectsFindings
      :ProjectID="ProjectID"
      :projectNumber="projectNumber"
      :divisionId="DivisionId"
      :projectSummary="projectSummary"
      :userCanEditProjectItems="userCanEditProjectItems"
    ></projectsFindings>
    <projectsCollections
      :ProjectID="ProjectID"
      :projectNumber="projectNumber"
      :projectSummary="projectSummary"
      :userCanEditProjectItems="userCanEditProjectItems"
    ></projectsCollections>
    <projectsReportedValues
      :ProjectID="ProjectID"
      :DivisionId="DivisionId"
      :projectNumber="projectNumber"
      :projectSummary="projectSummary"
      :userCanEditProjectItems="userCanEditProjectItems"
    ></projectsReportedValues>
  </div>
</template>
<script>
import Project from '@classes/Project'
import projectsDates from '@components/projects/projectsDates'
import projectsFindings from '@components/projects/projectsFindings'
import projectsReportedValues from '@components/projects/projectsReportedValues'
import projectsCollections from '@components/projects/projectsCollections'
export default {
  components: {
    projectsDates,
    projectsFindings,
    projectsReportedValues,
    projectsCollections,
  },
  props: {
    projectNumber: String,
    ProjectID: Number,
    DivisionId: Number,
    projectSummary: Array,
    userCanEditProjectItems: Boolean,
  },
  data() {
    return {}
  },
  created() {},
  computed: {},
  methods: {},
  watch: {},
}
</script>
<style scoped></style>
